<template>
  <div class="grid grid-cols-1 lg:grid-cols-2 col-gap-12 row-gap-11 items-center">
    <div class="lg:col-span-2">
      <div class="text-xl font-bold text-text leading-tight">{{ $t('formTitle') }}</div>
    </div>
    <VueCtkDateTimePicker v-model="date"
                          format="YYYY-MM-DD"
                          formatted="L"
                          :label="$t('dateLabel')"
                          :locale="$i18n.locale"
                          :min-date="minDateStart"
                          :auto-close="true"
                          :only-date="true"
                          :no-label="false"
                          :no-clear-button="true"
                          :no-button="true"
                          color="#486680"/>
    <div class="lg:col-span-2">
      <MoreSettings class="ml-8 mt-1 px-2 relative z-10 bg-block"
                    :active="true"
                    :text="$t('pickPaymentSystem')"/>
      <BankPicker :banks="availablePaymentSystemsList"
                  :active-id="!!paymentSystem ? paymentSystem.id : null"
                  class="-mt-3"
                  @select="paymentSystem = $event"/>
    </div>
    <div class="lg:col-span-2 flex flex-wrap items-center">
      <BaseButton theme="red"
                  class="w-78 lg:w-91 mr-8"
                  :loading="submitted"
                  @click="connect">
        {{ $t('addLabel') }}
      </BaseButton>
      <BaseButton theme="white"
                  class="w-50 lg:w-68 mt-8 lg:mt-0"
                  :loading="submitted"
                  @click="$emit('cancel')">
        {{ $t('cancel') }}
      </BaseButton>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import BaseButton from "@/components/UI/BaseButton";
import MoreSettings from "@/components/common/MoreSettings";
import BankPicker from "@/components/cabinet/SpaceSettings/BanksIntegrations/BankPicker/BankPicker";

export default {
  name: "PaymentSystemIntegrationForm",
  components: {BankPicker, MoreSettings, BaseButton},
  data() {
    return {
      submitted: false,
      paymentSystem: null,
      date: null,
    }
  },
  computed: {
    ...mapGetters('space', ['spaceInfo']),
    ...mapGetters('space/banks', ['availablePaymentSystemsList']),
    minDateStart() {
      return this.$moment().subtract(365, 'days').format('YYYY-MM-DD')
    }
  },
  methods: {
    ...mapActions('space/banks', ['connectBank']),
    async connect() {
      try {
        this.submitted = true;
        const data = {
          space_id: this.spaceInfo.id,
          date: this.date,
          bank: this.paymentSystem.code
        }
        const res = await this.connectBank(data);
        if (res.body.success) {
          this.$emit('connect', {link: res.body.data, connection: this.paymentSystem})
        } else {
          this.$toasted.error('Что-то пошло не так')
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.submitted = false;
      }
    }
  },
  created() {
    this.date = this.$moment().subtract(1, 'month').format('YYYY-MM-DD')
  },
  i18n: {
    messages: {
      en: {
        formTitle: 'Add payment system',
        dateLabel: 'Date from',
        pickPaymentSystem: 'Select payment system',
        addLabel: 'Add',
        cancel: 'Cancel'
      },
      ru: {
        formTitle: 'Добавить платежную систему',
        dateLabel: 'Дата начала',
        pickPaymentSystem: 'Выберите платежную систему',
        addLabel: 'Подключить',
        cancel: 'Отмена'
      },
    }
  }
}

</script>